var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { align: "center" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "2", md: "4", lg: "4", xl: "4" } },
        [
          [
            _vm.$vuetify.breakpoint.smAndDown &&
            !_vm.showBackBtn &&
            !_vm.showCloseBtn
              ? _c("v-app-bar-nav-icon", {
                  attrs: { color: _vm.headerStore.altDisplay ? "" : "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.drawerObj = !_vm.drawerObj
                    }
                  }
                })
              : _vm._e(),
            _vm.showBackBtn
              ? _c(
                  "a",
                  {
                    attrs: { role: "button" },
                    on: {
                      click: function($event) {
                        return _vm.handleNavigation("backBtn")
                      }
                    }
                  },
                  [
                    _c("re-icon", { staticClass: "primary--text" }, [
                      _vm._v("mdi-chevron-left")
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.showCloseBtn
              ? _c(
                  "a",
                  {
                    attrs: { role: "button" },
                    on: {
                      click: function($event) {
                        return _vm.handleNavigation("closeBtn")
                      }
                    }
                  },
                  [
                    _c("v-icon", { staticClass: "primary--text" }, [
                      _vm._v("mdi-close")
                    ])
                  ],
                  1
                )
              : _vm._e()
          ]
        ],
        2
      ),
      _c(
        "v-col",
        {
          staticClass: "d-flex justify-space-around",
          attrs: { cols: "8", md: "4", lg: "4", xl: "4" }
        },
        [
          !_vm.headerStore.altDisplay
            ? _c(
                "v-toolbar-title",
                { class: { "subtitle-1": _vm.$vuetify.breakpoint.smAndDown } },
                [_vm._v(_vm._s(_vm.headerText))]
              )
            : _c(
                "v-toolbar-title",
                { class: { "subtitle-1": _vm.$vuetify.breakpoint.smAndDown } },
                [_vm._v(_vm._s(_vm.terminalName))]
              )
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "d-flex justify-end",
          attrs: { cols: "2", md: "4", lg: "4", xl: "4" }
        },
        [
          _vm.tdMenuItems
            ? [
                _c(
                  "v-menu",
                  {
                    attrs: { "offset-y": "", dark: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-icon",
                                _vm._g(_vm._b({}, "v-icon", attrs, false), on),
                                [_vm._v("mdi-dots-vertical")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2497320641
                    )
                  },
                  [
                    _c(
                      "v-list",
                      {
                        staticClass: "py-0",
                        attrs: { color: "grey darken-3" }
                      },
                      _vm._l(_vm.tdMenuItems, function(item) {
                        return _c(
                          "v-list-item",
                          {
                            key: item.type,
                            attrs: { disabled: item.disabled },
                            on: {
                              click: function($event) {
                                return item.fn()
                              }
                            }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v(_vm._s(_vm.$t(item.text)))
                            ])
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }